import { environment } from '@envs/environment';
import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
  issuer: 'https://accounts.google.com',
  clientId: environment.web.client_id,
  redirectUri: environment.web.redirect_uri,
  responseType: 'token id_token',
  scope: 'openid profile email',
  strictDiscoveryDocumentValidation: false,
  showDebugInformation: true,
  sessionChecksEnabled: false,
  customQueryParams: { prompt: 'select_account' },
};
